import { render, staticRenderFns } from "./setting-company-branch-office-list.vue?vue&type=template&id=54d967fc&"
import script from "./setting-company-branch-office-list.vue?vue&type=script&lang=js&"
export * from "./setting-company-branch-office-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports